import React from 'react'
import { Outlet } from 'react-router-dom'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { Stack } from '@mui/material'
import useResponsive from '../hooks/useResponsive'

export function BasicLayout () {
  const lgUp = useResponsive('up', 'xl')
  return (
    <Stack alignItems="center">
      <Stack width={lgUp ? '80%' : '96%'} mb={2}>
        <Breadcrumbs />
        <Outlet />
      </Stack>
    </Stack>
  )
}
